import { AnimatePresence, motion } from "framer-motion";
import { XIcon } from "lucide-react";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
};

export const Modal = ({ isOpen, onClose, children, className }: Props) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
          onClick={onClose}
          className="fixed inset-0 bg-black/80 flex items-center justify-center z-40"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className={`max-h-[92%] max-w-[92%] overflow-y-auto custom-scrollbar bg-[#09172e] rounded-[16.8px] relative z-50 ${className}`}
          >
            <button
              onClick={onClose}
              className="absolute top-4 right-4 text-white"
            >
              <XIcon />
            </button>
            {children}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
